
// src/config/languages.ts
export type Language = {
    code: string;
    name: string;
};

export const languages: Language[] = [
    { code: "nl", name: "Nederlands" },
    { code: "en", name: "English" },
    { code: "de", name: "Deutsch" },
    { code: "sv", name: "Svenska" },
    { code: "fr", name: "Français" },
]; 